module.exports = __webpack_public_path__ + "static/media/BtnBanner1.33d83197.jpg";